import './FormulaFieldMetaData.scss';
import { CodeHighlight } from '@ui/general';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { SonarText } from '@ui/text';
export const FormulaFieldMetaData = ({ index, formulaFieldMetaData }) => {
    var _a;
    if (!formulaFieldMetaData) {
        return null;
    }
    return (React.createElement("div", { className: 'formula-field-meta-data' },
        React.createElement(SonarText, { weight: 'semibold' }, COPY_SPECIFIC.FORMULA_REFERENCES_FIELDS.replace('{0}', String((_a = formulaFieldMetaData.codeReferences) === null || _a === void 0 ? void 0 : _a.length))),
        React.createElement(CodeHighlight, { code: formulaFieldMetaData.code, codeReferences: formulaFieldMetaData.codeReferences, index: index })));
};
